module.exports = __webpack_public_path__ + "img/fontcontrol_jp.9b28a38.jpg";